import { CRM_SESSION_COOKIE } from '@realadvisor/constants';

const CRM_SESSION_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24;
export const CRM_SESSION_COOKIE_REFRESH_INTERVAL_MS = 12 * 60 * 60 * 1000;

const getCookieDomain = (hostname: string): string | null =>
  hostname.endsWith('.realadvisor.com') || hostname === 'realadvisor.com'
    ? '.realadvisor.com'
    : null;

export const syncCrmSessionCookie = (active: boolean) => {
  const maxAge = active ? CRM_SESSION_COOKIE_MAX_AGE_SECONDS : 0;
  const domain = getCookieDomain(window.location.hostname);
  const parts = [
    `${CRM_SESSION_COOKIE}=${active ? '1' : ''}`,
    'Path=/',
    `Max-Age=${maxAge}`,
    'SameSite=Lax',
  ];
  if (domain != null) {
    parts.push(`Domain=${domain}`);
  }
  if (window.location.protocol === 'https:') {
    parts.push('Secure');
  }
  document.cookie = parts.join('; ');
};
